import moment from 'moment-timezone';
import {
  guessCurrentTimeZone as newGuessTz,
  getTimeZoneOffsetValue as newGetTzOffset,
} from 'utils/datetime';

/**
 * guessCurrentTimeZone
 *
 * Guesses the user's current time zone.
 *
 * @returns { String } The time zone.
 * @deprecated Use guessCurrentTimeZone from utils/datetime
 */
export function guessCurrentTimeZone() {
  return newGuessTz();
}

/**
 * getActualTimeZone
 *
 * Helper function for migrating from using Moment's normalized timezone identifiers (e.g. `america_los_angeles`) to
 * the actual timezone name (e.g. `America/Los_Angeles`).
 *
 * @param timezone Moment timezone identifier
 */
export const getActualTimeZone = (timezone: string) => {
  return moment.tz(timezone).tz();
};

/**
 * getTimeZoneOffsetValue
 *
 * Gets the offset value in minutes of a time zone.
 *
 * @param { String } timeZoneString: The time zone to get offset of.
 * @param { Date } timeStamp: The date object to determine offset from.
 * @returns { String } The time zone offset.
 * @deprecated Use getTimeZoneOffsetValue from utils/datetime
 */
export function getTimeZoneOffsetValue(timeZoneString?: string): string;
export function getTimeZoneOffsetValue(timeZoneString: string, timeStamp: Date | number): number;
export function getTimeZoneOffsetValue(
  timeZoneString?: string,
  timeStamp?: Date | number,
): number | string {
  const date = typeof timeStamp === 'number' ? new Date(timeStamp) : timeStamp;
  return timeZoneString ? Math.abs(newGetTzOffset(timeZoneString, date) / (60 * 1000)) : '';
}
